<template>
  <div class="customer-create-customer-property" v-bind:class="{loaded}">
    <a-form layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Soort adres">
            <a-radio-group
                v-model="selectedAddressType"
                button-style="solid"
                v-on:change="handleAddressTypeChosen"
                v-bind:loading="loading">
              <a-radio-button v-for="(addressTypeName, addressType) in this.address_type"
                              v-bind:key="addressType" v-bind:value="addressType">
                {{ addressTypeName }}
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <property-input-component :address-type="selectedAddressType"
                              :emit-events="true" v-on:property-selected="handlePropertySelected"
                              v-on:property-deleted="handlePropertyDeleted"
                              :key="propertyInputComponentKey"
                              custom-button-name="Selecteer pand"
                              :customer-id="customer.id"/>
    <div v-if="propertyAlreadyExists" class="padding-top-15">
      <a-alert
          message="Dit adres is al aan deze klant gekoppeld"
          description="Wil je het adres opnieuw als huidige adres van de klant instellen, klik dan op de knop hieronder."
          show-icon
          type="warning"
      />
      <div class="text-right">
        <a-checkbox v-if="!hasSelectedMailAddressType" :checked="alsoCreateMailAddress"
                    @change="handleAlsoCreateMailAddressChecked">
          <b>Ook als postadres</b>
        </a-checkbox>
        <a-checkbox v-if="!hasSelectedVisitAddressType" :checked="alsoCreateVisitAddress"
                    @change="handleAlsoCreateVisitAddressChecked">
          <b>Ook als bezoekadres</b>
        </a-checkbox>
        <a-checkbox v-if="hasPartner" :checked="copyAddressToPartner" @change="handleCreatePartnerAddress">
          <b>Ook voor Partner</b>
        </a-checkbox>
        <a-button type="primary" style="margin-top: 15px;"
                  v-on:click="onClickSetExistingPropertyAsCurrent"
                  v-bind:loading="loadingExistingPropertyActivation">
          Als huidige adres instellen
        </a-button>
      </div>
    </div>
    <div v-else-if="hasCustomerProperty" class="padding-top-15">
      <CustomerPropertyEditComponent v-if="currentLivingConditionLoaded" :current-togglable="true"
                                     :detailed="true"
                                     v-bind:auto-save=false
                                     v-bind:auto-update=true
                                     v-bind:current-living-condition="currentLivingCondition"
                                     v-bind:customer-property="customerProperty"
                                     v-bind:partner-owner-percentage="partnerOwnerPercentage"
                                     v-bind:with-address-type=false
                                     v-on:update="onCustomerPropertyUpdated"
                                     v-on:partner-owner-percentage-changed="handlePartnerOwnerPercentageChanged"/>

      <template v-else>
        <a-row v-bind:gutter="15">
          <a-col v-bind:span="12">
            <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                      width="50%"></Skeleton>
            <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"></Skeleton>
            <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                      width="50%"></Skeleton>
            <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"></Skeleton>
            <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                      width="50%"></Skeleton>
            <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"
                      width="50%"></Skeleton>
          </a-col>
          <a-col v-bind:span="12">
            <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                      width="50%"></Skeleton>
            <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"></Skeleton>
            <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                      width="50%"></Skeleton>
            <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"></Skeleton>
            <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                      width="50%"></Skeleton>
            <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"
                      width="50%"></Skeleton>
          </a-col>
        </a-row>
      </template>

      <div class="pull-right">
        <a-checkbox v-if="!hasSelectedMailAddressType" :checked="alsoCreateMailAddress"
                    @change="handleAlsoCreateMailAddressChecked">
          <b>Ook als postadres</b>
        </a-checkbox>
        <a-checkbox v-if="!hasSelectedVisitAddressType" :checked="alsoCreateVisitAddress"
                    @change="handleAlsoCreateVisitAddressChecked">
          <b>Ook als bezoekadres</b>
        </a-checkbox>
        <a-checkbox v-if="hasPartner" :checked="copyAddressToPartner" @change="handleCreatePartnerAddress">
          <b>Adres voor Partner</b>
        </a-checkbox>
        <a-button :disabled="createButtonDisabled" type="primary" @click="handleCreateCustomerProperty">
          <pencil-icon/>
          Aanmaken
        </a-button>
      </div>
    </div>
    <a-modal v-model="customerPropertyCreatedModalVisible"
             cancel-text="Naar adressen overzicht"
             @cancel="handleToAddressesIndex"
             @ok="handleConfirmCustomerPropertyCreated" width="700">
      Gelukt
    </a-modal>
  </div>
</template>

<script>
import CustomerPropertyEditComponent from '~/modules/customer_property/components/EditComponent';
import PropertySearchByAddressComponent from '~/modules/property/components/SearchByAddressComponent';
import customerPropertyApi from '~/api/customer_property';
import customerApi from '~/api/customer'
import {Skeleton} from 'vue-loading-skeleton';
import {CustomerPropertyAddressTypeEnum} from "../../../enums";

export default {
  name: "CustomerCreateCustomerProperty",
  components: {
    CustomerPropertyEditComponent,
    PropertySearchByAddressComponent,
    Skeleton
  },
  props: {
    customerId: {
      required: false,
      default: null
    },
    customerProp: {
      type: Object,
      required: false,
      default: null
    },
  },
  data() {
    return {
      loaded: false,
      loading: false,
      loadingExistingPropertyActivation: false,
      countries: [],
      customer: null,
      customerProperty: null,
      currentLivingCondition: null,
      currentLivingConditionLoaded: false,
      activeKey: [],
      createModalVisible: false,
      customerPropertyCreatedModalVisible: false,
      customerPropertyCreatedModalTitle: 'Adres aangemaakt',
      copyDataToNewAddress: false,
      property: null,
      postalCode: null,
      number: null,
      numberLetter: null,
      numberAddition: null,
      searchAddressTitle: 'Adres aanmaken',
      // useInjectedProperty: true,
      address_type: {
        mail: 'Postadres',
        visit: 'Bezoekadres',
        // establishment: 'Vestiging',
      },
      selectedAddressType: null,
      afterCreate: 'address_overview',
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      creatingCustomerProperty: false,
      copyAddressToPartner: true,
      partnerData: null,
      newCombination: false,
      displayCombinationError: false,
      partnerOwnerPercentage: null,
      additionalAddressTypes: ['visit', 'mail'],
      alsoCreateMailAddress: true,
      alsoCreateVisitAddress: true,
      propertyInputComponentKey: 0,
    };
  },
  mounted() {
    if (this.customerProp === null && this.customerId === null) {
      throw new Error('Either the customer object or customer id is required.');
    }

    this.initCustomer().then(() => {
      this.loaded = true;
    });
  },
  computed: {
    propertyAlreadyExists() {
      return this.customerProperty !== null && typeof this.customerProperty.id !== "undefined" && this.customerProperty.id !== null
    },
    otherAddressType() {
      if (this.selectedAddressType === "mail") {
        return 'bezoekadres'
      }
      if (this.selectedAddressType === "visit") {
        return 'postadres'
      }
    },
    hasPartner() {
      if (typeof this.customer !== "undefined" && this.customer !== null) {
        return this.customer.has_partner
      }
    },
    hasProperty() {
      return this.property !== null;
    },
    hasCurrentLivingCondition() {
      return this.currentLivingCondition !== null;
    },
    hasCustomerProperty() {
      return typeof this.customerProperty !== "undefined" && this.customerProperty !== null;
    },
    hasSelectedAddressType() {
      return this.selectedAddressType !== null;
    },
    hasPropertyAndAddressType() {
      return this.hasSelectedAddressType && this.hasProperty && this.newCombination;
    },
    hasSelectedMailAddressType() {
      return this.selectedAddressType === 'mail'
    },
    hasSelectedVisitAddressType() {
      return this.selectedAddressType === 'visit'
    },
    createButtonDisabled() {
      return !this.hasPropertyAndAddressType || this.creatingCustomerProperty
    }
  },
  methods: {
    initCustomer() {
      return new Promise((resolve, reject) => {
        if (this.customerProp === null) {
          customerApi.find(this.customerId).then(response => {
            this.customer = response.data;
            resolve(this.customer);
            if (this.hasPartner) {
              this.initPartner()
            }
          }).catch(reject);
        } else {
          this.customer = this.customerProp;
          resolve(this.customer);
          if (this.hasPartner) {
            this.initPartner()
          }
        }
      });
    },
    initCustomerProperty() {
      return new Promise((resolve, reject) => {
        this.useInjectedProperty = false;
        this.postalCode = this.property.postal_code;
        this.number = this.property.number;
        this.numberAddition = this.property.number_addition;
        resolve(this.customerProperty);
      });
    },
    initPartner() {
      customerApi.findPartnerByCustomerId(this.customer.id, ['current_visit_customer_property']).then(response => {
        this.partnerData = response.data;
      }).catch();

    },
    initCustomerCurrentLivingCondition() {
      if (this.addressType === CustomerPropertyAddressTypeEnum.VISIT) {
        return customerCurrentLivingConditionApi.findOrCreateByCustomerAndProperty(this.customer.id, this.customerProperty.property_id)
            .then(response => {
              this.currentLivingCondition = response.data;
              this.currentLivingConditionLoaded = true;
            });
      } else {
        this.currentLivingConditionLoaded = true;

        return Promise.resolve();
      }
    },
    onClickSetExistingPropertyAsCurrent() {
      this.loadingExistingPropertyActivation = true;

      customerPropertyApi.setCurrent(this.customerProperty, this.additionalAddressTypes, this.copyAddressToPartner, this.partnerOwnerPercentage).then((response) => {
        this.creatingCustomerProperty = false
        this.handleCustomerPropertyCreated()
      }).finally(() => {
        this.loadingExistingPropertyActivation = false;
      });
    },
    handleCreateCustomerProperty() {
      this.creatingCustomerProperty = true
      if (this.customerProperty.is_current) {
        customerPropertyApi.createAsCurrent(this.customerProperty, this.additionalAddressTypes, this.copyAddressToPartner, this.partnerOwnerPercentage).then((response) => {
              this.creatingCustomerProperty = false
              this.handleCustomerPropertyCreated()
            }
        ).catch(error => {
          if (typeof error.response !== "undefined") {
            let errorResponse = error.response.data;
            if (errorResponse.error && errorResponse.error.errors) {
              for (let attribute in errorResponse.error.errors) {
                let errors = errorResponse.error.errors[attribute];
                errors.forEach(error => {
                  this.$notification['error']({
                    message: 'Er ging iets mis',
                    description: error,
                  });
                })
              }
            }
          }
          this.creatingCustomerProperty = false
          reject();
        })
      } else {
        customerPropertyApi
            .create(this.customerProperty, this.additionalAddressTypes, this.copyAddressToPartner, this.partnerOwnerPercentage).then((response) => {
          this.creatingCustomerProperty = false
          this.handleCustomerPropertyCreated()
        }).catch(error => {
          if (typeof error.response !== "undefined") {
            let errorResponse = error.response.data;
            if (errorResponse.error && errorResponse.error.errors) {
              for (let attribute in errorResponse.error.errors) {
                let errors = errorResponse.error.errors[attribute];
                errors.forEach(error => {
                  this.$notification['error']({
                    message: 'Er ging iets mis',
                    description: error,
                  });
                })
              }
            }
          }
          this.creatingCustomerProperty = false
          reject();
        })
      }
    },
    handleCustomerPropertyCreated() {
      // this.customerPropertyCreatedModalVisible = true;
      this.handleToAddressesIndex();
    },
    rerenderPropertyInputComponent() {
      this.propertyInputComponentKey += 1;
    },
    handleShowPropertySearchModal() {
      this.confirmModalVisible = true;
      this.searchAddressTitle = 'Adres wijzigen';
    },
    onCustomerPropertyUpdated(customerProperty) {
      this.customerProperty = customerProperty;
    },
    handleAddressTypeChosen(addressType) {
      if (addressType && typeof this.property !== 'undefined' && this.property !== null)
        this.handleAddressTypeAndPropertyChosen(addressType)
    },
    handlePropertySelected(property) {
      this.property = property
      this.handleAddressTypeAndPropertyChosen()
    },
    handlePropertyDeleted() {
      this.property = null
      this.customerProperty = null
      this.currentLivingCondition = null
    },
    handleToCreateModel() {
      this.createModalVisible = true;
    },
    handleConfirmCustomerPropertyCreated() {
      this.customerPropertyCreatedModalVisible = false;
      this.selectedAddressType = null;
      this.property = null;
      this.customerProperty = null;
      this.createModalVisible = false;
      this.rerenderPropertyInputComponent();
    },
    handleCreatePartnerAddress() {
      this.copyAddressToPartner = !this.copyAddressToPartner;
    },
    handleCreateBothAddressTypes() {
      this.createBothAddressTypes = !this.createBothAddressTypes;
    },
    handleAlsoCreateMailAddressChecked() {
      this.alsoCreateMailAddress = !this.alsoCreateMailAddress;
      if (this.alsoCreateMailAddress && !this.additionalAddressTypes.includes('mail')) {
        this.additionalAddressTypes.push('mail')
      } else {
        this.additionalAddressTypes = this.additionalAddressTypes.filter(v => v !== 'mail');
      }
    },
    handleAlsoCreateVisitAddressChecked() {
      this.alsoCreateVisitAddress = !this.alsoCreateVisitAddress;
      if (this.alsoCreateVisitAddress && !this.additionalAddressTypes.includes('visit')) {
        this.additionalAddressTypes.push('visit')
      } else {
        this.additionalAddressTypes = this.additionalAddressTypes.filter(v => v !== 'visit');
      }
    },
    handleToAddressesIndex() {
      window.location.href = '/customer/' + this.customer.id + '/property';
    },
    handlePartnerOwnerPercentageChanged(partnerPercentage) {
      this.partnerOwnerPercentage = partnerPercentage
    },
    handleAddressTypeAndPropertyChosen() {
      this.loading = true;

      customerPropertyApi.findByCustomerAndPropertyAndAddressType(this.customerId, this.property.id, this.selectedAddressType).then(response => {
        this.customerProperty = response.data;
        this.newCombination = false
        this.displayCombinationError = true
        this.initCustomerCurrentLivingCondition();
      }).catch(error => {
        if (error.response && error.response.status && error.response.status === 404) {
          this.currentLivingConditionLoaded = true;
          this.customerProperty = {
            property_id: this.property.id,
            customer_id: this.customer.id,
            address_type: this.selectedAddressType,
          };
          this.newCombination = true;
          this.displayCombinationError = false;
        } else {
          throw error;
        }
      }).finally(() => {
        this.loading = true;
      });
    }
  }
}
</script>
<style scoped>
.create-customer-properties {
  position: relative;
  margin-bottom: 15px;
}

.create-button {
  margin-top: 15px;
}

.address-label {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 500;
}
</style>
